import {EVENT_SET_FORM_COMPLETENESS} from "../constants";

const setFormCompleteness = (complete) => ({
  type : EVENT_SET_FORM_COMPLETENESS,
  payload : complete,
});

export default setFormCompleteness;
